export default ({type, title, message}) => (dispatch, getState) => {
  const time = new Date().getTime()
  const randomNumber = Math.random() * 10000
  const id = `${randomNumber}-${time}`
  const notification = {type, title, message, id}
  dispatch({type: 'add_notification', notification})
}



/** WEBPACK FOOTER **
 ** ./app/actions/addNotification.js
 **/